import { render, staticRenderFns } from "./refund-amount.vue?vue&type=template&id=b6b2de5c"
import script from "./refund-amount.vue?vue&type=script&lang=ts"
export * from "./refund-amount.vue?vue&type=script&lang=ts"
import style0 from "./refund-amount.vue?vue&type=style&index=0&id=b6b2de5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports